import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { BooksReadByLevelData } from 'teacher-ui-client/components/giraffe/charts/dashboard/books-read/by-level'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface BooksReadByLevelResponse {
  books_read_by_level: {
    range: string
    count: number
  }[]
}

export async function booksReadByLevel(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<BooksReadByLevelData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('books_read_by_level', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<BooksReadByLevelResponse>(url, query)
  if (!data) return null

  const { books_read_by_level } = data
  const hasNoCounts = books_read_by_level.every(({ count }) => count === 0)
  if (books_read_by_level.length === 0 || hasNoCounts) return null

  return books_read_by_level
}
